<app-pagetitle
  title="{{ nameApp }}"
  [breadcrumbItems]="breadCrumbItems"
></app-pagetitle>

<div class="row">
  <div class="col-sm-12">
    <div class="card card-border">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-6 text-sm-right">
            <button *hasPermission="{app: constant.PLAN_ANIOS, permission: [constant.CREAR]}"
              type="button"
              class="btn btn-sm btn-success waves-effect"
              (click)="openModal()"
            >
              <i class="fas fa-plus fa-lg mr-1"></i> Nuevo
            </button>
          </div>
        </div>
      </div>

      <div class="container card-body table-responsive">
        <table
          datatable
          [dtOptions]="dtOptions"
          [dtTrigger]="dtTrigger"
          class="table table-striped table-bordered row-border hover"
        >
          <thead>
            <tr>
              <th>Nro.</th>
              <th>Plan institucional</th>
              <th>Año</th>
              <th>Fecha inicio</th>
              <th>Fecha fin</th>
              <th>Vigencia</th>
              <th>Estado</th>
              <!-- <th>Estado</th> -->
              <th *hasPermission="{app: constant.PLAN_ANIOS, permission: [constant.ACTUALIZAR, constant.BORRAR]}">Acciones</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let subSistem of dataAniosPlanInst; let indice = index">
              <td>{{ indice + 1 }}</td>
              <td>{{ subSistem.nombrePlan }}</td>
              <td>{{ subSistem.anio }}</td>
              <td>{{ subSistem.fechaInicio| date: 'dd-MM-yyyy' }}</td>
              <td>{{ subSistem.fechaFin| date: 'dd-MM-yyyy' }}</td>
              <td>{{ subSistem.vigencia == "S" ? "SI" : "NO" }}</td>
              <td>{{ subSistem.estado == "1" ? "Activo" : "Inactivo" }}</td>
              <td *hasPermission="{app: constant.PLAN_ANIOS, permission: [constant.ACTUALIZAR, constant.BORRAR]}" class="text-center">
                <div class="row">
                  <button *hasPermission="{app: constant.PLAN_ANIOS, permission: [constant.ACTUALIZAR]}"
                    type="button"
                    tooltip="Editar"
                    class="btn btn-sm btn-link waves-effect rounded-pill col px-0"
                    title="Editar este registro"
                    (click)="
                      updatePlanAnios(
                        subSistem,
                        dataAniosPlanInst

                      )
                    "
                  >
                    <i class="fas fa-pencil-alt fa-lg"></i>
                  </button>
                  <button *hasPermission="{app: constant.PLAN_ANIOS, permission: [constant.BORRAR]}"
                    type="button"
                    class="btn btn-sm btn-link waves-effect col px-0"
                    title="Eliminar este registro"
                    (click)="deletePlanAnios(subSistem.idSprAnio)"
                  >
                    <i class="fas fa-trash-alt fa-lg"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="modal-catalogo">
        <div
          class="modal fade show"
          style="overflow-y: scroll"
          id=""
          tabindex="-1"
          role="dialog"
          aria-labelledby="scrollmodalLabel"
          [class.mostrar]="mostrarModal"
        >
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header bg-azul text-white">
                <h4 class="modal-title text-white" id="exampleModalLabel1">
                  Plan acción
                </h4>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  (click)="closeModal()"
                >
                  <small aria-hidden="true">&times;</small>
                </button>
              </div>
            </div>
          </div>
        </div>

        <jw-modal id="deleteAnios">
          <div class="modal-dialog" style="padding-top: 15%">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title" id="myCenterModalLabel">
                  Advertencia!
                </h4>
                <button
                  type="button"
                  class="btn-close"
                  (click)="modal.close()"
                ></button>
              </div>
              <div class="modal-body">
                <p class="pl-4">
                  <i
                    class="pl-2 fas fa-exclamation-circle text-warning fa-lg fa-2x"
                  ></i
                  >&nbsp; &nbsp; Esta seguro que desea eliminar este registro?
                </p>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary waves-effect"
                  (click)="modal.close()"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="confirmDelete()"
                >
                  Si, borrar!
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </jw-modal>

        <jw-modal id="{{ nameModal }}">
          <!-- MODAL PARA CREAR Y EDITAR -->
          <div class="modal-dialog" style="padding-top: 6%">
            <div class="modal-content">
              <div class="modal-header pb-3">
                <h3 class="modal-title">{{ namePlanAnios }}</h3>
                <button
                  type="button"
                  class="btn-close"
                  (click)="modal.close()"
                  aria-label="Close"
                ></button>
              </div>

              <div class="card-body pT-4">
                <form
                  class="needs-validation"
                  id="formCatAnios"
                  [formGroup]="formAnios"
                  autocomplete="off"
                  (ngSubmit)="createPlanAnios()"
                >
                  <div class="form-group row">
                    <input
                      type="hidden"
                      id="idSprPlanInstitucional"
                      formControlName="idSprPlanInstitucional"
                      requiered
                      class="is-invalid"
                    />
                    <div class="form-floating mb-3">
                      <select
                        #a
                        class="form-select"
                        formControlName="idSprPlanInstitucional"
                        [(ngModel)]="selectPlan"
                        (change)="
                          findAniosPlanes($event, dataPlanesInstActivos)
                        "
                        required="true"
                        [ngClass]="{
                          'is-invalid':
                            this.formAnios.get('idSprPlanInstitucional')
                              ?.errors && this.formSubmitted,
                          'is-valid':
                            this.formAnios.value.idSprPlanInstitucional
                        }"
                      >
                        <option
                          *ngFor="let planIns of dataPlanesInstActivos"
                          value="{{ planIns.idSprPlanInstitucional }}"
                        >
                          {{ planIns.nombre }}
                        </option>
                      </select>
                      <small
                        class="invalid-feedback"
                        *ngIf="this.formAnios.get('idSprPlanInstitucional')?.errors?.['required'] && this.formSubmitted"
                        >Campo requerido</small
                      >
                      <label>Plan institucional</label>
                    </div>
                  </div>
                  <div class="form-group row">
                    <input
                      type="hidden"
                      id="idSprAnio"
                      formControlName="idSprAnio"
                      requiered
                      class="is-invalid"
                    />
                    <div class="form-floating mb-3">
                      <select
                        #a
                        class="form-select"
                        *ngIf="dataAniosPlanes"
                        formControlName="idSprAnio"
                        (change)="createFechaInicioFin($event)"
                        required="true"
                        [ngClass]="{
                          'is-invalid':
                            this.formAnios.get('idSprAnio')?.errors &&
                            this.formSubmitted,
                          'is-valid': this.formAnios.value.anio
                        }"
                      >
                        <option value="">Elige una opción</option>

                        <option
                          *ngFor="let row of vectorAnio"
                          value="{{ row.idSprAnio }}"
                        >
                          {{ row.anio }}
                        </option>
                      </select>
                      <small
                        class="invalid-feedback"
                        *ngIf="this.formAnios.get('anio')?.errors?.['required'] && this.formSubmitted"
                        >Campo requerido</small
                      >
                      <label>Año</label>
                    </div>
                  </div>
                  <div class="form-floating mb-3">
                    <input
                      type="date"
                      class="form-control"
                      drequired="true"
                      min="anio-04-20"
                      placeholder="fechaInicio"
                      formControlName="fechaInicio"
                      (change)="controlFechaInicio($event)"
                    />
                    <small
                      class="invalid-feedback"
                      *ngIf="this.formAnios.get('fechaInicio')?.errors?.['required'] && this.formSubmitted"
                      >Campo requerido</small
                    >
                    <div class="col text-danger">
                      <span
                        class="font-italic"
                        *ngIf="
                          this.formAnios.get('fechaInicio').errors?.fechaInicio
                        "
                        >La fecha debe estar comprendida entre
                        {{
                          this.formAnios.get("fechaInicio")?.errors.fechaInicio
                        }}
                        y
                        {{ this.formAnios.get("fechaInicio")?.errors.fechaFin }}
                      </span>
                    </div>

                    <label>Fecha inicio</label>
                  </div>

                  <div class="form-floating mb-3">
                    <input
                      type="date"
                      class="form-control"
                      required="true"
                      placeholder="fechaFin"
                      formControlName="fechaFin"
                      (change)="controlFechaFin($event)"
                      date
                    />
                    <small
                      class="invalid-feedback"
                      *ngIf="this.formAnios.get('fechaFin')?.errors?.['required'] && this.formSubmitted"
                      >Campo requerido</small
                    >
                    <label>Fecha fin</label>
                  </div>

                  <div class="form-floating mb-3">
                    <select
                      class="form-select"
                      id="vigencia"
                      formControlName="vigencia"
                      required="true"
                      [ngClass]="{
                        'is-invalid':
                          this.formAnios.get('vigencia')?.errors &&
                          this.formSubmitted,
                        'is-valid': this.formAnios.value.vigencia
                      }"
                    >
                      <option value="S" selected>Si</option>
                      <option value="N">No</option>
                    </select>
                    <small
                      class="invalid-feedback"
                      *ngIf="this.formAnios.get('vigencia')?.errors?.['required'] && this.formSubmitted"
                      >Campo requerido</small
                    >
                    <label>Vigencia</label>
                  </div>

                  <div class="form-floating mb-3">
                    <select
                      class="form-select"
                      id="estado"
                      formControlName="estado"
                      required="true"
                      [ngClass]="{'is-invalid': this.formAnios.get('estado')?.errors && this.formSubmitted,'is-valid': !this.formAnios.get('estado')?.errors,}"
                    >
                      <option value="1" selected>Activo</option>
                      <option value="2">Inactivo</option>
                    </select>
                    <small
                      class="invalid-feedback"
                      *ngIf="this.formAnios.get('estado')?.errors?.['required'] && this.formSubmitted"
                      >Campo requerido</small
                    >
                    <label>Estado</label>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary waves-effect"
                      data-dismiss="modal"
                      (click)="closeModal()"
                    >
                      Cancelar
                    </button>
                    <button type="submit" class="btn btn-info">Guardar</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </jw-modal>
      </div>
    </div>
  </div>
</div>
